import GigyaService from "../services/gigya-service";
// import AdobeAnalyticsService from "../services/adobe-analytics-service";
import config from "../constants/config";

const { ENV_SUFIX } = config;

export const useOnInit = () => {
  const mfaApiKey = process.env[`REACT_APP_MFA_CDC_API_KEY${ENV_SUFIX}`];
  const dcrApiKey = process.env[`REACT_APP_DCR_CDC_API_KEY${ENV_SUFIX}`];

  const isMfaFlow =
    window.location.pathname.toLowerCase().includes("mfa") ||
    document.referrer.toLowerCase().includes("mfa") ||
    sessionStorage.getItem("gig_apikey") === mfaApiKey;
  
  const isDcrFlow =
    window.location.pathname.toLowerCase().includes("dcr") ||
    document.referrer.toLowerCase().includes("dcr") ||
    sessionStorage.getItem("gig_apikey") === dcrApiKey;

  // Set up appropriate script based on flow type
  if (isDcrFlow) {
    if (dcrApiKey) {
      sessionStorage.setItem("gig_apikey", dcrApiKey);
    }
    GigyaService.setUpDcrCdcScript();
  } else if (isMfaFlow) {
    if (mfaApiKey) {
      sessionStorage.setItem("gig_apikey", mfaApiKey);
    }
    GigyaService.setUpMfaCdcScript();
  } else {
    GigyaService.setUpCdcScript();
  }
  // Note: No script setup needed for cloud flow
  // const onInit = async () => {
  //   AdobeAnalyticsService.setUpAdobeAnalytics();
  // };

  // onInit();
};
